import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgOverwhelmedSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M31.37 19.2c0 2.28 1.75 3.89 3.94 3.89 2.38 0 3.89-1.56 3.93-3.95-.45-1.41-1.09-2.74-1.9-3.95l-.18-.24c-.08-.11-.16-.23-.24-.35-.64-.88-1.37-1.69-2.18-2.42-.28.92-.71 1.89-1.35 2.72-.94 1.23-2.02 2.6-2.02 4.3Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M39.89 22.2c-.93 1.49-2.57 2.39-4.58 2.39-3.1 0-5.44-2.32-5.44-5.39 0-2.18 1.27-3.83 2.29-5.15l.05-.06c.66-.85 1.04-1.91 1.27-2.85C30.82 9.18 27.55 8 24 8 15.18 8 8 15.18 8 24s7.18 16 16 16 16-7.18 16-16c0-.61-.04-1.21-.11-1.8Zm-9.74 7.79c0 1.46-1.19 2.64-2.64 2.64h-7.03c-1.46 0-2.64-1.19-2.64-2.64v-.67c0-1.83 1.49-3.32 3.32-3.32h5.68c1.83 0 3.32 1.49 3.32 3.32v.67h-.01Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M35.31 8.72s0 3.7-1.92 6.18c-.94 1.22-2.03 2.6-2.03 4.3 0 2.28 1.74 3.89 3.94 3.89 2.41 0 3.94-1.61 3.94-4.05 0-1.73-1.17-2.85-2.09-4.08-1.72-2.32-1.84-6.24-1.84-6.24Z",
    fill: "currentColor"
  }));
}

export { SvgOverwhelmedSelectedEmojiSecondary as default };
